module.exports = __webpack_public_path__ + "assets/img/11@3x.66a69ac3.png";